import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const SettingPageLayout = (props: Props) => {
  return (
    <><Outlet /></>
  );
};

export default SettingPageLayout;